<app-generic-container>
  <!-- Usamos el panel genérico -->
  <app-generic-panel [title]="this.isNew ? panelTitle : panelTitleTwo"
    [description]="this.isNew ? panelDescription : panelDescriptionTwo" [icon]="panelIcon">

    <div class="last-update-container" *ngIf="conectiaLicence">
      <button *ngIf="!isNew" class="btn btn-fill btn-primary float-right sync-innuva-button" type="button"
        (click)="updateAndShowLoadingSpinner({innuvaSync: true}, $event)">

        <ng-container *ngIf="showLoadingInnuvaSpinner; else showRefreshIcon">
          <i class="material-icons spinner-border spinner-border-sm"></i>
          Sincronizando
        </ng-container>

        <ng-template #showRefreshIcon>
          <i class="material-icons">refresh</i>
          Sincronizar con innuva
        </ng-template>

      </button>
    </div>
    <form class="form-horizontal ng-untouched ng-pristine ng-valid" (ngSubmit)="onSubmitCompany()"
      #appCompanyNewForm="ngForm" novalidate="">
      <div class="row">
        <div class="col-sm-12 col-lg-6">
          <div class="row justify-content-center">

            <div class="col-10 ml-2">
              <div class="block">

                <legend class="pl-0 mt-2">Datos de la empresa</legend>

                <app-custom-company-selector *ngIf="isNew && conectiaLicence" dataSize="7" placeHolder="Empresas"
                  [(ngModel)]="model" [required]="true" (selectedValueChange)="companySelectedChanged($event)">
                </app-custom-company-selector>

                <app-form-input-app *ngIf="!isNew && conectiaLicence" [labelText]="'Empresas'" [isRequired]="true">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.name" name="CompanyName"
                    required readonly>
                </app-form-input-app>

                <app-form-input-app *ngIf=" !conectiaLicence" [labelText]="'Nombre de la empresa'" [isRequired]="true">
                  <input class="form-control" (ngModelChange)="setCompanyNameOffline($event)" autocomplete="off"
                    type="text" [(ngModel)]="model.name" name="CompanyName" required>
                </app-form-input-app>

                <app-form-input-app *ngIf="!conectiaLicence" [labelText]="'NIF/CIF'" [isRequired]="true">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.identifierNumber"
                    name="IdentifierNumber" (ngModelChange)="setCompanyIdentifierNumberOffline($event)" required>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Código de App'" [isRequired]="false">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.appId"
                    name="AppCompanyCode" readonly>
                </app-form-input-app>

                <app-form-input-app *ngIf="conectiaLicence" [labelText]="'Código Innuva'" [isRequired]="false">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.companyCode"
                    name="CompanyCode" required readonly>
                </app-form-input-app>

                <br *ngIf="livesLicence">

                <app-form-input-app [labelText]="'Enlace myReport!n'" [isRequired]="false">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.myreportin"
                    (ngModelChange)="setMyreportin($event)" name="MyReportin"
                    [ngClass]="{'invalid-field ': !myReportinValid}" [readonly]="!myReportinLicense">
                  <small *ngIf="!myReportinValid" class="text-danger">
                    El enlace no es válido (https://app.myreportin.com/public/xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx)
                  </small>
                </app-form-input-app>

                <legend *ngIf="livesLicence" class="pl-0 mt-5">Parametrización de la empresa</legend>

                <div [class.mt-4]="!livesLicence">
                  <app-dropdown-formularios *ngIf="isAdmin" dataSize="7" placeHolder="Usuarios asignados"
                    [selectedValue]="model && model.netUsers"
                    (selectedValueChange)="companySelectedNetUsersChanged($event)" [required]="true"
                    [isDisabled]="model.companyCode == null && conectiaLicence" [dropdownType]="'NetUsers'"
                    [id]="model.company1" [multiple]="true">
                  </app-dropdown-formularios>
                </div>

                <app-dropdown-formularios *ngIf="livesLicence && model && model.netUsers" dataSize="7"
                  placeHolder="Validador RRHH" [selectedValue]="model && model.hrValidators"
                  [netUsersData]="model && model.netUsers"
                  (selectedValueChange)="companySelectedHRValidatorChanged($event)" [required]="true"
                  [isDisabled]="model.companyCode == null" [dropdownType]="'HRUsers'" [id]="model.company1"
                  [multiple]="true">
                </app-dropdown-formularios>

                <!--  <legend class="pl-0 mt-2">Fecha de antigüedad en nómina</legend> -->
                <!-- <app-dropdown-formularios dataSize="7" placeHolder="Tipo de antigüedad"
                  [selectedValue]="model && model.seniorityCompanyDate  + '' "
                  (selectedValueChange)="companySelectedPayRollDateTypeChanged($event)" [required]="true"
                  [disabled]="model && model.companyCode == null" [dropdownType]="'PayRollType'">
                </app-dropdown-formularios> -->
                <div *ngIf="!livesLicence" class="mt-3"></div>
                <app-dropdown-formularios *ngIf="livesLicence||conectiaLicence" dataSize="7"
                  placeHolder="Invitaciones automáticas" [selectedValue]="model && model.sendAutoInvite  + '' "
                  (selectedValueChange)="companySelectedAutoInvitationsChanged($event)" [required]="true"
                  [disabled]="model && model.companyCode == null" [dropdownType]="'YesNo'">
                </app-dropdown-formularios>

                <app-dropdown-formularios *ngIf="hostelLicence && livesLicence" dataSize="7"
                  placeHolder="Solicitudes de bolsa de vacaciones"
                  [selectedValue]="model && model.holidayBagAllowed  + '' "
                  (selectedValueChange)="companySelectedHolidayBagAllowChanged($event)" [required]="true"
                  [disabled]="model && model.companyCode == null" [dropdownType]="'YesNo'">
                </app-dropdown-formularios>

                <app-dropdown-formularios dataSize="7" placeHolder="Validador de bolsa de vacaciones"
                  *ngIf="hostelLicence && holidayBagValidatorAllowed  && livesLicence && model && model.netUsers "
                  [selectedValue]="model && model.holidayBagValidator" [netUsersData]="model && model.netUsers"
                  (selectedValueChange)="companySelectedHolidayBagValidatorChanged($event)" [required]="true"
                  [isDisabled]="model.companyCode == null" [dropdownType]="'HolidayBagUsers'" [id]="model.company1">
                </app-dropdown-formularios>





                <app-dropdown-formularios *ngIf="livesLicence" dataSize="7" placeHolder="Solicitudes de anticipos"
                  [selectedValue]="model && model.advanceAllowed  + '' "
                  (selectedValueChange)="companySelectedAdvanceAllowChanged($event)" [required]="true"
                  [disabled]="model && model.companyCode == null" [dropdownType]="'YesNo'">
                </app-dropdown-formularios>

                <app-dropdown-formularios dataSize="7" placeHolder="Validador de anticipos"
                  *ngIf=" advancesValidatorAllowed && livesLicence && model && model.netUsers"
                  [selectedValue]="model && model.advanceValidator"
                  (selectedValueChange)="companySelectedAdvanceValidatorChanged($event)"
                  [netUsersData]="model && model.netUsers" [required]="advancesValidatorAllowed ? true : false"
                  [isDisabled]="model.companyCode == null" [dropdownType]="'HolidayBagUsers'" [id]="model.company1">
                </app-dropdown-formularios>

                <app-form-input-app [labelText]="'Fecha inicio de solicitud de anticipos'"
                  [isRequired]="advancesValidatorAllowed ? true : false"
                  *ngIf=" advancesValidatorAllowed  && livesLicence">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.advanceInitialDay"
                    (ngModelChange)="setAdvanceInitialDay($event)" name="advanceInitialDay"
                    [ngClass]="{'invalid-field ': !advanceInitialDayValid}" maxlength="2">
                  <small *ngIf="!advanceInitialDayValid" class="text-danger">
                    Se debe introducir un día válido entre 1 y 31 y antes de la fecha límite de solicitud de
                    anticipos</small>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Fecha límite de solicitud de anticipos'"
                  [isRequired]="advancesValidatorAllowed ? true : false"
                  *ngIf=" advancesValidatorAllowed && livesLicence">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.advanceLimitDay"
                    (ngModelChange)="setAdvanceLimitDay($event)" name="advanceLimitDay"
                    [ngClass]="{'invalid-field ': !advanceLimitDayValid}" maxlength="2">
                  <small *ngIf="!advanceLimitDayValid" class="text-danger">
                    Se debe introducir un día válido entre 1 y 31 y después de la fecha de inicio de solicitud de
                    anticipos </small>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Importe máximo mensual de anticipos (€)'"
                  [isRequired]="advancesValidatorAllowed ? true : false"
                  *ngIf=" advancesValidatorAllowed && livesLicence">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.advanceLimitAmount"
                    (ngModelChange)="setAdvanceLimitAmount($event)" name="advanceLimitAmount"
                    [ngClass]="{'invalid-field ': !advanceLimitAmountValid}">
                  <small *ngIf="!advanceLimitAmountValid" class="text-danger">
                    Se debe introducir un número válido
                  </small>
                </app-form-input-app>

              </div>
            </div>


          </div>

        </div>

        <div class="col-sm-12 col-lg-6">
          <div class="row justify-content-center">
            <div class="col-10 mt-2">

              <legend *ngIf="livesLicence" class="pl-0">Mensajes de comunicación de notificaciones</legend>
              <app-form-input-app *ngIf="livesLicence" [labelText]="'Texto notificación de solicitud aceptada'"
                [isRequired]="true">
                <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.pushAcceptText"
                  (ngModelChange)="setPushAccept($event)" name="PushNotificationAccepted" required maxlength="100">
                <small *ngIf="!pushAcceptValid" class="text-danger">
                  Este campo es obligatorio
                </small>
              </app-form-input-app>
              <app-form-input-app *ngIf="livesLicence" [labelText]="'Texto notificación de solicitud rechazada'"
                [isRequired]="true">
                <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.pushDenyText"
                  (ngModelChange)="setPushReject($event)" name="PushNotificationRejected" required maxlength="100">
                <small *ngIf="!pushRejectValid" class="text-danger">
                  Este campo es obligatorio
                </small>
              </app-form-input-app>
              <legend *ngIf="livesLicence" class="pl-0 mt-3">Mensajes de comunicación de correo electrónico</legend>
              <app-form-input-app *ngIf="livesLicence" [labelText]="'Texto notificación de solicitud aceptada'"
                [isRequired]="true">
                <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.mailAcceptText"
                  (ngModelChange)="setMailAccept($event)" name="MailNotificationAccepted" required maxlength="200">
                <small *ngIf="!mailAcceptValid" class="text-danger">
                  Este campo es obligatorio
                </small>
              </app-form-input-app>
              <app-form-input-app *ngIf="livesLicence" [labelText]="'Texto notificación de solicitud rechazada'"
                [isRequired]="true">
                <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.mailDenyText"
                  (ngModelChange)="setMailReject($event)" name="MailNotificationRejected" required maxlength="200">
                <small *ngIf="!mailRejectValid" class="text-danger">
                  Este campo es obligatorio
                </small>
              </app-form-input-app>

              <!-- mostrar y editar sello e imagen  -->
              <div class="col-sm-12 col-lg-12 mt-3 mb-3">
                <div class="row justify-content-sm-start">

                  <div class="col-lg-5 p-0">
                    <div class="block text-center d-flex flex-column align-items-center">
                      <legend class="text-left p-0">Imagen de App</legend>
                      <app-image-viewer [base64Image]="model.companyImageData.base64FullData"
                        [type]="'image'"></app-image-viewer>
                      <app-image-uploader [isStamp]="false" (imageSelected)="handleImageSelected($event)">
                      </app-image-uploader>
                    </div>
                  </div>

                  <!-- <div class="col-5">
                    <div class="block text-center d-flex flex-column align-items-center">
                      <legend>Firma Nómina</legend>
                      <app-image-viewer [base64Stamp]="model.companyStampData.base64FullData"
                        [type]="'stamp'"></app-image-viewer>
                      <app-image-uploader [isStamp]="true"
                        (stampSelected)="handleStampSelected($event)"></app-image-uploader>
                    </div>
                  </div> -->



                </div>
              </div>

              <div class="mt-3" *ngIf="livesLicence">
                <dx-check-box style="color: #f38642" class=" mb-2"
                  [value]="model.customRedirection?.showButtonRedirection"
                  (onValueChanged)="handleVisibleCustomButtonChange($event)" text="Mostrar botón personalizable">
                </dx-check-box>
                <legend class="p-0 mb-4">Botón personalizable de app</legend>

                <div class="block" *ngIf="model.customRedirection?.showButtonRedirection ">
                  <div class="d-flex">
                    <div class="col-5 pl-2">
                      <div class="block text-center d-flex flex-column align-items-center">
                        <small *ngIf="!customButtonImageValid" class="text-danger">
                          Este campo es obligatorio
                        </small>
                        <app-image-viewer [type]="'customRedirection'"
                          [base64customImage]="model.customRedirection?.image"></app-image-viewer>
                        <app-image-uploader [isStamp]="false" (imageSelected)="handleCustomButtonImageChange($event)">
                        </app-image-uploader>
                      </div>
                    </div>
                    <div class="col-8 pl-0 ">
                      <app-form-input-app [labelText]="'Nombre para mostrar'" [isRequired]="false">
                        <input class="form-control" autocomplete="off" type="text"
                          [ngModel]="model.customRedirection?.name"
                          (ngModelChange)="handleCustomButtonNameChange($event)" name="name"
                          [ngClass]="{'invalid-field ': !customButtonNameValid}">
                        <small *ngIf="!customButtonNameValid" class="text-danger">
                          Este campo es obligatorio
                        </small>
                      </app-form-input-app>
                      <app-form-input-app [labelText]="'Url de redirección en Android'" [isRequired]="false">
                        <input class="form-control" autocomplete="off" type="text"
                          [ngModel]="model.customRedirection?.androidUrl"
                          (ngModelChange)="handleCustomButtonAndroidUrlChange($event)" name="androidUrl"
                          [ngClass]="{'invalid-field ': !customButtonAndroidUrlValid}">
                        <small *ngIf="!customButtonAndroidUrlValid" class="text-danger">
                          El enlace no es válido (https://xxxx o https://play.google.com/store/apps/details?id=xxx)
                        </small>
                      </app-form-input-app>
                      <app-form-input-app [labelText]="'Url de redirección en iOS'" [isRequired]="false">
                        <input class="form-control" autocomplete="off" type="text"
                          [ngModel]="model.customRedirection?.iosUrl"
                          (ngModelChange)="handleVisibleCustomIosUrlChange($event)" name="iosUrl"
                          [ngClass]="{'invalid-field ': !customButtonIosUrlValid}">
                        <small *ngIf="!customButtonIosUrlValid" class="text-danger">
                          El enlace no es válido (https://xxxx o https://apps.apple.com/app/idxxxxxxxx)
                        </small>
                      </app-form-input-app>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>




        <!-- Botonera -->
        <div class="row col-12 float-right ">
          <label class="col-12"></label>
          <div class="col-12">
            <div class="form-group form-button">
              <button class="btn btn-fill btn-primary float-right" type="submit"
                [disabled]="!companyFormEdit || loading">{{loading ? 'Guardando' :
                'Guardar' }}</button>
              <a class="btn btn-fill btn-outline-white float-right" routerLink="../">Volver</a>

            </div>
          </div>
        </div>
      </div>
    </form>
  </app-generic-panel>

  <app-generic-panel [title]="'Organigrama'" [description]="'Organigrama de la empresa'" [icon]="'account_tree'"
    *ngIf="!isNew && livesLicence"
    [tooltipText]="'Podrás descargar la explicacion de cómo se genera el Organigrama pulsando el botón de &quot;¿CÓMO SE GENERA?&quot; encima del botón de &quot;ACTUALIZACIÓN MANUAL&quot;'">


    <div class="last-update-container">
      <div class="last-update">
        Última actualización: {{ lastUpdateDate }}
      </div>
      <button class="btn btn-fill btn-primary float-right" type="button"
        (click)="updateAndShowLoadingSpinner({}, $event)">
        <i class="material-icons">refresh</i>
        ACTUALIZACIÓN MANUAL
      </button>
      <button class="btn btn-fill btn-primary how-button" type="button" (click)="openPDF()">
        <i class="material-icons">
          lightbulb_outline </i>
        ¿CÓMO SE GENERA?
      </button>
    </div>
    <div *ngIf="showLoadingSpinner" class="text-center">
      <div class="spinner-border" role="status"
        style="width: 6.5rem; height: 6.5rem;  border-width: 0.5rem; margin-bottom: 5rem;">
      </div>
    </div>

    <app-org-chart class="chart-container" [data]="orgData" *ngIf="showOrgChart && orgData"
      (editEvent)=" handleEditEvent($event)">
    </app-org-chart>

  </app-generic-panel>


  <app-generic-panel [title]="'Sección'" [description]="'Mostrar y editar sección'" [icon]="'extension'"
    id="focusSection" *ngIf="!isNew && livesLicence">
    <form class="form-horizontal ng-untouched ng-pristine ng-valid" (ngSubmit)="onSubmitSections()"
      #appConpanyNewForm="ngForm" novalidate="">
      <div class="row">
        <div class="col-sm-12 col-lg-6">
          <div class="row justify-content-center">

            <div class="col-10 ml-2">
              <div class="block">

                <app-dropdown-formularios dataSize="7" placeHolder="Sección"
                  [selectedValue]="model && model.companyCode"
                  (selectedValueChange)="companySelectedSectionChanged($event)" [required]="section.section1"
                  [disabled]="model && model.companyCode == null" [dropdownType]="'Section'"
                  [selectedId]="section.section1" [id]="model.company1">
                </app-dropdown-formularios>

                <app-dropdown-formularios dataSize="7" placeHolder="Delegar validación"
                  [selectedValue]="section.delegateResponsibleAllow"
                  (selectedValueChange)="companySelectedDelegateValidationChanged($event)"
                  [required]="section.delegateResponsibleAllow" [isDisabled]="!isSectionSelected"
                  [dropdownType]="'YesNo'">
                </app-dropdown-formularios>

                <app-dropdown-formularios dataSize="7" placeHolder="Doble validación"
                  [selectedValue]="section.dualResponsibleAllow"
                  (selectedValueChange)="companySelectedDoubleValidationChanged($event)"
                  [required]="section.dualResponsibleAllow" [isDisabled]="!isSectionSelected" [dropdownType]="'YesNo'">
                </app-dropdown-formularios>

                <!-- Comentar cuando se haga el comportamiento de doble validador -->
                <!-- <div (click)="newFeatureAlert()">
                  <app-dropdown-formularios dataSize="7" placeHolder="Delegar validación"
                    [selectedValue]="section.delegateResponsibleAllow"
                    (selectedValueChange)="companySelectedDelegateValidationChanged($event)"
                    [required]="section.delegateResponsibleAllow" [isDisabled]="true" [dropdownType]="'YesNo'">
                  </app-dropdown-formularios>


                  <app-dropdown-formularios dataSize="7" placeHolder="Doble validación"
                    [selectedValue]="section.dualResponsibleAllow"
                    (selectedValueChange)="companySelectedDoubleValidationChanged($event)"
                    [required]="section.dualResponsibleAllow" [isDisabled]="true" [dropdownType]="'YesNo'">
                  </app-dropdown-formularios>

                </div> -->
              </div>
            </div>


          </div>

        </div>

        <div class="col-sm-12 col-lg-6">
          <div class="row justify-content-center">
            <div class="col-10">

              <!-- Descomentar cuando se haga el comportamiento de doble validador -->

              <app-form-input-app [labelText]="'Validador'" [isRequired]="false" [margin0Input]="true">
                <input class="form-control" autocomplete="off" type="text" [(ngModel)]="section.validatorName"
                  [readonly]="true" name="Validator" [ngClass]="'validator-readonly-field'">
              </app-form-input-app>

              <app-dropdown-formularios dataSize="7" placeHolder="Validador delegado"
                [selectedValue]="model && model.companyCode"
                (selectedValueChange)="companySelectedDelegateValidatorChanged($event)" [required]="false"
                [isDisabled]="isCompanySelectedDelegatedValidatorReadOnly" [dropdownType]="'Users'"
                [selectedId]="section.delegateResponsible" [id]="model.company1"
                [notSelectableId]="[section.validator, section.dualResponsible]" [section]="section.section1">
              </app-dropdown-formularios>

              <app-dropdown-formularios dataSize="7" placeHolder="Validador doble"
                [selectedValue]="model && model.companyCode"
                (selectedValueChange)="companySelectedDoubleValidatorChanged($event)" [required]="false"
                [isDisabled]="isCompanySelectedDoubleValidatorReadOnly" [dropdownType]="'Users'"
                [selectedId]="section.dualResponsible" [id]="model.company1"
                [notSelectableId]="[section.delegateResponsible, section.validator]" [section]="section.section1">
              </app-dropdown-formularios>




              <!-- Comentar cuando se haga el comportamiento de doble validador -->
              <!-- <div (click)="newFeatureAlert($event)">
                <app-dropdown-formularios dataSize="7" placeHolder="Validador delegado"
                  [selectedValue]="model && model.companyCode"
                  (selectedValueChange)="companySelectedDelegateValidatorChanged($event)" [required]="false"
                  [isDisabled]="true" [dropdownType]="'Users'" [selectedId]="section.delegateResponsible"
                  [id]="model.company1" [notSelectableId]="[section.validator, section.dualResponsible]">
                </app-dropdown-formularios>

                <app-dropdown-formularios dataSize="7" placeHolder="Validador doble"
                  [selectedValue]="model && model.companyCode"
                  (selectedValueChange)="companySelectedDoubleValidatorChanged($event)" [required]="false"
                  [isDisabled]="true" [dropdownType]="'Users'" [selectedId]="section.dualResponsible"
                  [id]="model.company1" [notSelectableId]="[section.delegateResponsible, section.validator]">
                </app-dropdown-formularios>
              </div> -->

            </div>
          </div>
        </div>

        <!-- Botonera -->
        <div class="row col-12 float-right ">
          <label class="col-12"></label>
          <div class="col-12">
            <div class="form-group form-button">
              <button class="btn btn-fill btn-primary float-right" type="submit"
                [disabled]="!sectionsFormEdit">Guardar</button>
              <a class="btn btn-fill btn-outline-white float-right" routerLink="../">Volver</a>
            </div>
          </div>
        </div>
      </div>
    </form>
  </app-generic-panel>

  <app-generic-panel [title]="'Notificaciones de solicitudes'"
    [description]="'Configuración de SMTP para envío de correo electronico'" [icon]="'event_available'"
    *ngIf="!isNew  && livesLicence">
    <form class="form-horizontal ng-untouched ng-pristine ng-valid" (ngSubmit)="onSubmitSmtp()"
      #appConpanyNewForm="ngForm" novalidate="">
      <div class="row">



        <div class="dx-field pl-auto pr-auto w-100">
          <div class="smtp-check">
            <dx-check-box style="color: #007ac3" (onValueChanged)="handleEnableChange($event)"
              [(value)]="checkSmtpChecked" text="Envío automático con LiveslHR">
            </dx-check-box>
            <i class="material-icons info-icon"
              [ngbTooltip]="'Si activa esta opción los correos electrónicos se enviarán desde el servidor SMTP de LiveslHR'">info</i>

            <button class="btn btn-fill btn-primary float-right ml-auto" type="button" (click)="handleTestSmtp()"
              [disabled]="!checkSmtpChecked && !smtpFormEdit">
              <fa-icon icon="paper-plane" size="1x"></fa-icon>
              PROBAR SMTP
            </button>
          </div>

        </div>


        <div class="col-sm-12 col-lg-6">
          <div class="row justify-content-center">

            <div class="col-10 ml-2">
              <div class="block">

                <!-- Si se habilita enable se muestra el campo con datos si no se muestra en readonly y vacio -->
                <app-form-input-app [labelText]="'Servidor de salida (SMTP)'" [isRequired]="false"
                  *ngIf="this.checkSmtpChecked">
                  <input class="form-control" autocomplete="off" type="text" name="SmtpOutputServer"
                    [readonly]="this.checkSmtpChecked">
                </app-form-input-app>
                <app-form-input-app [labelText]="'Servidor de salida (SMTP)'" [isRequired]="true"
                  *ngIf="!this.checkSmtpChecked">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="smtpModel.outServer"
                    (ngModelChange)="setSmtpOut($event)" name="SmtpOutputServer" [readonly]="this.checkSmtpChecked"
                    [ngClass]="{'invalid-field ': !outServerValid}">
                  <small *ngIf="!outServerValid" class="text-danger">
                    Este campo es obligatorio
                  </small>
                </app-form-input-app>

                <!-- Si se habilita enable se muestra el campo con datos si no se muestra en readonly y vacio -->
                <app-form-input-app [labelText]="'Puerto del servidor de salida (SMTP)'" [isRequired]="false"
                  *ngIf="this.checkSmtpChecked">
                  <input class="form-control" autocomplete="off" type="text"
                    [ngClass]="{'invalid-field ': !smtportPortValid}" name="SmtpOutputPort"
                    [readonly]="this.checkSmtpChecked">
                </app-form-input-app>
                <app-form-input-app [labelText]="'Puerto del servidor de salida (SMTP)'" [isRequired]="true"
                  *ngIf="!this.checkSmtpChecked">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="smtpModel.outServerPort"
                    (ngModelChange)="setSmtpOutPort($event)" [ngClass]="{'invalid-field ': !smtportPortValid}"
                    name="SmtpOutputPort" [readonly]="this.checkSmtpChecked"
                    [ngClass]="{'invalid-field ': !outServerPortValid}">
                  <small *ngIf="!outServerPortValid" class="text-danger">
                    Este campo es obligatorio
                  </small>
                </app-form-input-app>

              </div>
            </div>


          </div>

        </div>

        <div class="col-sm-12 col-lg-6">
          <div class="row justify-content-center">
            <div class="col-10">

              <!-- Si se habilita enable se muestra el campo con datos si no se muestra en readonly y vacio -->
              <app-form-input-app [labelText]="'Correo electrónico'" [isRequired]="false" *ngIf="this.checkSmtpChecked">
                <input class="form-control" autocomplete="off" type="mail" name="SmtpMail"
                  [readonly]="this.checkSmtpChecked">
              </app-form-input-app>
              <app-form-input-app [labelText]="'Correo electrónico'" [isRequired]="true" *ngIf="!this.checkSmtpChecked">
                <input class="form-control" autocomplete="off" type="mail" [(ngModel)]="smtpModel.user"
                  (ngModelChange)="setSmtpMail($event)" name="SmtpMail" [readonly]="this.checkSmtpChecked"
                  [ngClass]="{'invalid-field ': !userValid}">
                <small *ngIf="!userValid" class="text-danger">
                  Este campo es obligatorio
                </small>
              </app-form-input-app>


              <!-- Si se habilita enable se muestra el campo con datos si no se muestra en readonly y vacio -->
              <app-form-input-app [labelText]="'Contraseña'" [isRequired]="false" *ngIf="this.checkSmtpChecked">
                <div class="input-group">
                  <input class="form-control" autocomplete="off" type="{{ showPassword ? 'text' : 'password' }}"
                    name="SmtpPass" [readonly]="this.checkSmtpChecked">
                  <div class="input-group-append">
                    <i class="material-icons" (click)="togglePasswordVisibility()"
                      style="cursor: pointer;position: absolute;right: 0.3em;color: gray;top: 11%;">
                      {{ showPassword ? 'visibility' : 'visibility_off' }}
                    </i>
                  </div>
                </div>
              </app-form-input-app>

              <app-form-input-app [labelText]="'Contraseña'" [isRequired]="true" *ngIf="!this.checkSmtpChecked">
                <div class="input-group">
                  <input class="form-control" autocomplete="off" type="{{ showPassword ? 'text' : 'password' }}"
                    [(ngModel)]="smtpModel.password" (ngModelChange)="setSmtpPass($event)" name="SmtpPass"
                    [readonly]="this.checkSmtpChecked" [ngClass]="{'invalid-field ': !passwordValid}">
                  <div class="input-group-append">
                    <i class="material-icons" (click)="togglePasswordVisibility()"
                      style="cursor: pointer;position: absolute;right: 0.3em;color: gray;top: 11%;">
                      {{ showPassword ? 'visibility' : 'visibility_off' }}
                    </i>
                  </div>
                </div>
                <small *ngIf="!passwordValid" class="text-danger">
                  Este campo es obligatorio
                </small>
              </app-form-input-app>

            </div>
          </div>
        </div>

        <!--  <div class="dx-field pl-auto pr-auto w-100">
          <div class="smtp-check mt-3">
            <dx-check-box style="color: #007ac3" (onValueChanged)="handleTlsSslChange($event)"
              [(value)]="smtpModel.tlsSsl" text="TLS/SSL" [disabled]="smtpModel.enable">
            </dx-check-box>
          </div>
        </div> -->

        <!-- Botonera -->
        <div class="row col-12 float-right ">
          <label class="col-12"></label>
          <div class="col-12">
            <div class="form-group form-button">
              <button class="btn btn-fill btn-primary float-right" type="submit"
                [disabled]="!smtpFormEdit">Guardar</button>
              <a class="btn btn-fill btn-outline-white float-right" routerLink="../">Volver</a>
            </div>
          </div>
        </div>
      </div>
    </form>
  </app-generic-panel>


</app-generic-container>